import { ContentView, ContentViewProps, FullyQualifiedLocales } from '@brandfolder/content-view';
import { StandardDialog } from '@brandfolder/react';
import React, { FunctionComponent, useContext } from 'react';

import { getStandardDialogLabels } from '@translations';

import { ContentViewContext } from './context/content-view';

type ContentViewDialogProps = Partial<Pick<ContentViewProps, 'locale'>>;

export const ContentViewDialog: FunctionComponent<ContentViewDialogProps> = ({ locale }) => {
  const { assetKey, setAssetKey } = useContext(ContentViewContext);

  if (BFG.resource.type === 'portal') return null;

  return (
    <StandardDialog
      id="content-view-dialog"
      labels={getStandardDialogLabels()}
      open={!!assetKey}
      setOpen={(open: boolean): void => {
        if (!open) {
          setAssetKey(null);
        }
      }}
      showFooter={false}
      title={'TODO - get asset name via useAsset'}
    >
      <ContentView
        assetKey={assetKey}
        bearerToken={BFG.BF_Token}
        locale={locale || BFG.locales.staticSiteLocale as FullyQualifiedLocales || 'en'}
        resource={{ key: BFG.resource.key, type: BFG.resource.type === 'workspace' ? 'collection' : BFG.resource.type }}
      />
    </StandardDialog>
  );
};
